import { DrawerCloseButtonStyleConfig } from '../types';

export const styleConfig: DrawerCloseButtonStyleConfig = {
  baseStyle: {
    top: '4',
    right: '4',
  },
};
